export default __webpack_public_path__ + "static/media/galerie5.ad4a666b.jpg";